import { render, staticRenderFns } from "./Governments.vue?vue&type=template&id=796f08d8&scoped=true&"
import script from "./Governments.vue?vue&type=script&lang=js&"
export * from "./Governments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "796f08d8",
  null
  
)

export default component.exports